import { css } from "@emotion/react";

export const textTruncateStyles = css`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const fullPageViewBlockStyles = css`
  cursor: pointer;
  vertical-align: middle;
  position: relative;
  top: 2px;
`;
